import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {GlobalState} from '../../../global.state';

@Component({
  selector: 'ba-content-top',
  styleUrls: ['./baContentTop.scss'],
  templateUrl: './baContentTop.html',
})
export class BaContentTop {

  public activePageTitle:string = '';

  constructor(
    private _state:GlobalState,
    public translate: TranslateService) {
    this._state.subscribe('menu.activeLink', (activeLink) => {
      console.log(activeLink);
      if (activeLink.title) {
        let a = String(activeLink.title);
        this.translate.get(a.toLowerCase()).subscribe((res: string) => {
          this.activePageTitle = res;
        });
      } else {
          this.activePageTitle = '';
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baContentTop/baContentTop.component.ts